const Symbols = {
  USD: '$',
  ILS: '₪',
  EUR: '€',
  GBP: '£'
};

export const formatCurrency = (value, currencyCode) => {
  return `${Symbols[currencyCode] || ''}${value || 0}`;
};
